import { BaselineMethodKey, VariantWithDemandMetrics } from "~/context/DemandPlanProvider"
import { shouldShowMatchCountAlert, shouldShowSimilarityAlert } from "~/utils/matchQualityUtils"

export function calculateAlertLogic(
  variant: VariantWithDemandMetrics,
  brandMatchQuality?: number,
  minMatchCountThreshold?: number,
) {
  let reviewBaseline = true
  if (variant.manualBaseline != null) {
    reviewBaseline = false
  }
  if (variant.baselineMethod === BaselineMethodKey.CarryOver) {
    reviewBaseline = false
  }

  if (variant.baselineMethod === BaselineMethodKey.CarryOverFromOtherCollections) {
    reviewBaseline = false
  }

  if (variant.avgSimilarity) {
    reviewBaseline = shouldShowSimilarityAlert({
      similarity: variant.avgSimilarity,
      brandMatchQuality: brandMatchQuality,
    })
  }

  if (
    shouldShowMatchCountAlert({
      baselineMatchCount: variant.baselineMatchCount,
      minMatchCountThreshold,
    })
  ) {
    reviewBaseline = true
  }

  if (variant.baselineMethod === BaselineMethodKey.None) {
    reviewBaseline = true
  }

  if (variant.baselineMethod === BaselineMethodKey.AvgInBaselineCollection) {
    reviewBaseline = true
  }

  // Custom match we always see as verified and good, so we don't show the alert
  if (
    variant.baselineMethod === BaselineMethodKey.CustomMatches ||
    variant.currentBaselineMethod === BaselineMethodKey.CustomMatches
  ) {
    reviewBaseline = false
  }

  const effectiveForecast = variant.manualFinalForecast ?? variant.forecastTotal
  const forecastBelowPreOrders = effectiveForecast < variant.preOrderQuantitySource
  return {
    reviewBaseline,
    forecastBelowPreOrders,
  }
}
